import axios from 'axios';
import { getServerError } from '../error/error-service';
import { ApiTimeTrackingLog, ApiCreateTimeTrackingLogData, ApiGetTimeTrackingListParams } from './time-tracking-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getTimeTrackingList = (documentKey: string, params: ApiGetTimeTrackingListParams) => {
    return axios.get<ApiTimeTrackingLog[]>(`${DocApiBaseUrl}/document/${documentKey}/time-tracking`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const createTimeTrackingLog = (documentKey: string, data: ApiCreateTimeTrackingLogData) => {
    return axios.post(`${DocApiBaseUrl}/document/${documentKey}/time-tracking`, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const updateTimeTrackingLog = (logId: number, data: ApiCreateTimeTrackingLogData) => {
    return axios.put(`${DocApiBaseUrl}/time-tracking/${logId}`, { ...data })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const deleteTimeTrackingLog = (logId: number, data: ApiCreateTimeTrackingLogData) => {
    return axios.delete(`${DocApiBaseUrl}/time-tracking/${logId}`, { data })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}